import { SetState } from 'zustand';
import { OutputTechnology, UpdateInventoryMeterOutputDto } from '@enmon/commons/lib/tools';
import { UploadFile } from 'antd';
import { SerializedMeterRegister } from '@enmon/commons';
import { SerializedManualRecord } from '@enmon/commons/lib/enmon';
import type { InstallMeterStore } from '../../useStore';

const INITIAL_STATE: InstallationDetailStepState = {
  registers: [],
  outputs: [],
  registersCountersReadingAt: undefined,
  meterMountTechnology: undefined,
};

export interface InstallationMeterRegisterFormValues extends SerializedMeterRegister {
  counter: SerializedManualRecord['counter'] | null;
  counterPhotos: UploadFile<unknown>[];
}

export interface InstallationDetailStepFormValues {
  registers: InstallationMeterRegisterFormValues[];
  outputs: UpdateInventoryMeterOutputDto[];
  meterMountTechnology?: OutputTechnology | null;
}

export interface InstallationDetailStepState extends InstallationDetailStepFormValues {
  registersCountersReadingAt?: Date;
}

export type InstallationDetailStepSlice = InstallationDetailStepState & {
  resetInstallationDetailStepSlice: (initValues?: Partial<InstallationDetailStepState>) => void;
  setInstallationDetailStepValues: (
    update: (prevValues: InstallationDetailStepState) => Partial<InstallationDetailStepState>,
  ) => void;
};

export const createInstallationDetailStepSlice = (set: SetState<InstallMeterStore>): InstallationDetailStepSlice => ({
  ...INITIAL_STATE,
  resetInstallationDetailStepSlice: (initValues = {}) => set({ ...INITIAL_STATE, ...initValues }),
  setInstallationDetailStepValues: update => set(prevState => ({ ...prevState, ...update(prevState) })),
});
